export function getDate(value: Date | undefined): Date | undefined {
  if (!!value) {
    return value instanceof Date
      ? value
      : new Date((value as string).endsWith('Z') ? value : `${value}Z`);
  }

  return value;
}

export enum DateTimeType {
  Current,
  EndOfDay,
  Midnight
}

export const getDateByTime = (
  date?: Date,
  hours?: number,
  minutes?: number,
  seconds?: number,
  milliseconds?: number
): Date | undefined => {
  const value = getDate(date);
  if (value) {
    value.setHours(
      hours ?? value.getHours(),
      minutes ?? value.getMinutes(),
      seconds ?? value.getSeconds(),
      milliseconds ?? value.getMilliseconds()
    );
    return value;
  }
  return undefined;
};

export const getDateTime = (date?: Date, type?: DateTimeType): Date | undefined => {
  switch (type) {
    case DateTimeType.EndOfDay:
      return getDateByTime(date, 23, 59, 59, 999);
    case DateTimeType.Midnight:
      return getDateByTime(date, 0, 0, 0, 0);
    default:
      return getDate(date);
  }
};

export const getToday = (type?: DateTimeType): Date => getDateTime(new Date(), type)!;

const getDatePlusDays = (
  value: Date | undefined,
  days: number,
  type?: DateTimeType
): Date | undefined => {
  const dateFormat = getDateTime(value, type);
  if (dateFormat != null) {
    const newDate = new Date(dateFormat);
    newDate.setDate(dateFormat.getDate() + days);
    return newDate;
  }
  return undefined;
};

export const getTomorrow = (type?: DateTimeType): Date => getDatePlusDays(new Date(), 1, type)!;

export const getYesterday = (type?: DateTimeType): Date => getDatePlusDays(new Date(), -1, type)!;

export const getNextDay = (date?: Date, type?: DateTimeType): Date | undefined =>
  getDatePlusDays(date, 1, type);

export const isToday = (date?: Date): boolean => {
  if (!date) {
    return false;
  }
  const today = new Date();

  return (
    today.getFullYear() === date.getFullYear() &&
    today.getMonth() === date.getMonth() &&
    today.getDate() === date.getDate()
  );
};
